/* eslint-disable indent */
// EXTERNAL DEPENDENCIES
import React, { useEffect, useState } from 'react'

// COMPONENTS
import { Card, Row } from '@paypalcorp/pp-react'
import { CoverPhotoOverlay } from '../photo-overlays/cover-photo-overlay'

// HELPERS
import { parseAndTrackClick } from '@/utils'

// CONSTANTS
import { DEFAULT_BACKGROUND_PHOTO } from '@/common/images/profile'

// TEST IDS
import {
  COVER_PHOTO_IMAGE_CONTAINER_TEST_ID,
  COVER_PHOTO_IMAGE_TEST_ID,
  COVER_PHOTO_IMAGE_ELEMENT_TEST_ID,
} from '@/constants/test-ids'

// STYLES
import styles from './styles.module.less'

/**
 * Displays the cover photo as a background image
 */
export default function CoverPhotoDisplay({
  src,
  handleClick,
  isLoading,
  fpti,
  isDisplayPhoto,
  isOwnerPhoto,
}: Readonly<{
  src: string
  handleClick?: () => void
  isLoading?: boolean
  isDisplayPhoto?: boolean
  fpti?: string
  isOwnerPhoto?: boolean
}>) {
  const [updatedSrc, setUpdatedSrc] = useState(src)
  useEffect(() => {
    setUpdatedSrc(src)
  }, [src])

  let photoClassName = isDisplayPhoto
    ? 'displayCoverPhotoImg'
    : 'uploadCoverPhotoImg'

  if (handleClick && !isOwnerPhoto) {
    photoClassName = 'roundedCoverPhotoImg'
  }

  const handleClickWithFpti = () => {
    parseAndTrackClick(fpti)
    handleClick()
  }

  const finalClass = styles[photoClassName]

  return (
    <div data-testid={COVER_PHOTO_IMAGE_CONTAINER_TEST_ID}>
      {isLoading ? (
        <Row noGutters>
          <div className={finalClass}>
            <Card isLoading />
          </div>
        </Row>
      ) : (
        <div className={styles.overlayContainer}>
          <div
            className={updatedSrc ? styles.flexContainer : finalClass}
            style={
              updatedSrc
                ? null
                : {
                    backgroundImage: `url("${DEFAULT_BACKGROUND_PHOTO}")`,
                  }
            }
            data-testid={COVER_PHOTO_IMAGE_TEST_ID}
            data-fpti={fpti}
          >
            {updatedSrc ? (
              <img
                className={finalClass}
                src={updatedSrc}
                alt=''
                data-testid={COVER_PHOTO_IMAGE_ELEMENT_TEST_ID}
              />
            ) : null}
            {handleClick ? (
              <CoverPhotoOverlay
                handleClick={handleClickWithFpti}
                isOwnerPhoto={isOwnerPhoto}
              />
            ) : null}
          </div>
        </div>
      )}
    </div>
  )
}
